"use strict";
import React from "react";
import classNames from "classnames";
import * as styles from "./Link-css";
export var LinkIconAnimation = /* @__PURE__ */ ((LinkIconAnimation2) => {
  LinkIconAnimation2["SlideStart"] = "slide-start";
  LinkIconAnimation2["SlideEnd"] = "slide-end";
  return LinkIconAnimation2;
})(LinkIconAnimation || {});
export var LinkTheme = /* @__PURE__ */ ((LinkTheme2) => {
  LinkTheme2["Dark"] = "dark";
  LinkTheme2["Light"] = "light";
  return LinkTheme2;
})(LinkTheme || {});
const Link = React.forwardRef(
  ({ href, rel, onClick, target, children, className, iconStart, iconEnd, iconAnimation, id, disabled, ...rest }, ref) => {
    const isExternal = href?.includes("://") && href[0] !== "#";
    const defaultRel = isExternal ? "noopener noreferrer" : void 0;
    const defaultTarget = isExternal ? "_blank" : void 0;
    const linkRel = rel ?? defaultRel;
    const linkTarget = target ?? defaultTarget;
    const Component = !!onClick && !href ? "button" : "a";
    return /* @__PURE__ */ React.createElement(
      Component,
      {
        className: classNames("kl-link", styles.link, className),
        href: disabled ? void 0 : href,
        rel: linkRel,
        target: linkTarget,
        onClick: disabled ? void 0 : onClick,
        disabled,
        "aria-disabled": disabled,
        role: "link",
        id,
        ref,
        ...rest
      },
      !!iconStart && /* @__PURE__ */ React.createElement("span", { className: classNames("kl-link__icon", styles.icon({ position: "start", animation: iconAnimation })) }, iconStart),
      /* @__PURE__ */ React.createElement("span", { className: classNames("kl-link__text", styles.text) }, children),
      !!iconEnd && /* @__PURE__ */ React.createElement("span", { className: classNames("kl-link__icon", styles.icon({ position: "end", animation: iconAnimation })) }, iconEnd)
    );
  }
);
export default Link;
